import Action from 'actions';
import BaseExecutor from 'services/sports/default/base-executor';
import {MinPlayersValidator} from 'services/validations/validators/min-players-validator';
import {MinPlayersOnPositionValidator} from 'services/validations/validators/min-players-on-position-validator';
import {MinTeamsValidator} from 'services/validations/validators/min-teams-validator';
import {MinGamesValidator} from 'services/validations/validators/min-games-validator';
import {MaxLockedPlayersValidator} from 'services/validations/validators/max-locked-players-validator';
import {MinTiersValidator} from 'services/validations/validators/min-tiers-validator';
import BaseValidator from 'services/validations/base-validator';

class TiersValidatorBuilder extends BaseExecutor {
    getInterface() {
        const {
            playersData: {preparedPlayers, players, slates},
            playersLock,
            sportConfig,
        } = Action.getState();

        const playersDividedByPosition = preparedPlayers.groupedBy.position();
        const playersGroupedByExposureMin = preparedPlayers.groupedBy.property('exposureMin');

        const minPlayersValidator = new MinPlayersValidator();
        minPlayersValidator.setDependencies({
            sportConfig,
            playersDividedByPosition,
            playersLock,
        });

        const minTeamsValidator = new MinTeamsValidator();
        minTeamsValidator.setDependencies({
            sportConfig,
            playersDividedByPosition,
        });

        const minGamesValidator = new MinGamesValidator();
        minGamesValidator.setDependencies({
            sportConfig,
            playersDividedByPosition,
        });

        const maxLockedPlayersValidator = new MaxLockedPlayersValidator();
        maxLockedPlayersValidator.setDependencies({
            sportConfig,
            playersLock,
        });

        const minTiersValidator = new MinTiersValidator();
        minTiersValidator.setDependencies({
            sportConfig,
            players,
            slates,
        });

        const validator = new BaseValidator();
        validator.addSubValidators([
            minPlayersValidator,
            minTeamsValidator,
            minGamesValidator,
            maxLockedPlayersValidator,
            minTiersValidator,
        ]);

        return validator;
    }
}

export {TiersValidatorBuilder};
